export const DefaultSettings = {
    earth_r: 1.6,
    earth_center: {x: 0, y: 0, z: 0},
    textOption: {
        size: 0.1,
        height: 0.05
    }
}
